module.exports = __webpack_public_path__ + "img/search-header-nav-below-lincoln.6d37aef5.png";